/** A clean HTTP EOF is not proof that an AI SDK response finished. */
export async function fetchCompleteAssistantStream(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const response = await fetch(input, init);
  if (!response.ok || !response.body || !response.headers.get('content-type')?.includes('text/event-stream')) return response;
  let pending = '';
  let finished = false;
  const decoder = new TextDecoder();
  const stream = response.body.pipeThrough(new TransformStream<Uint8Array, Uint8Array>({
    transform(chunk, controller) {
      pending += decoder.decode(chunk, { stream: true });
      const lines = pending.split('\n');
      pending = lines.pop() ?? '';
      for (const line of lines) {
        if (!line.startsWith('data: ')) continue;
        try {
          const event = JSON.parse(line.slice(6));
          if (event.type === 'finish') finished = true;
        } catch { /* SSE comments and [DONE] are not finish events. */ }
      }
      controller.enqueue(chunk);
    },
    flush() {
      if (!finished) throw new Error('Assistant stream ended before completion. Reload the saved response or retry.');
    },
  }));
  return new Response(stream, { status: response.status, headers: response.headers });
}
